



































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import * as firebase from 'firebase/app';
import {ESettori} from "@/types";
import {removeUndefined} from "@/utils";

@Component({
    components: {},
    name: "AnnouncementForm",
    computed: {
        ...mapGetters({announcements: 'announcements', user: 'user'})
    }
})
export default class AnnouncementForm extends Vue {
    @Prop(String) readonly announcementUuid!: string;
    @Prop({type: Boolean, default: true}) readonly showSaveButton?: boolean;

    private announcements?: any[];
    private save_state:number = 0;
    private user?: any;
    private _announcementUuid: string = '';
    private defaultValues = {
        settore: "",
        num_persone: 1,
        periodo_da: "",
        periodo_a: "",
        giorni_per_settimana: null,
        patente: undefined,
        patente_agricola: undefined,
        veicolo: undefined,
        alloggio: undefined,
        titolo: "",
        descrizione: ""
    }

    get saveState(){
        return this.save_state;
    }

    set saveState(val: number) {
        if (val == 1) {
            this.save_state = 1;
        }
        if (val == 2) {
            setTimeout(() => {
                this.save_state = 2;
                setTimeout(() => {
                    this.save_state = 0
                }, 2000);
            }, 2000)
        }
        if (val == 3) {
            setTimeout(() => {
                this.save_state = 3;
                setTimeout(() => {
                    this.save_state = 0
                }, 2000);
            }, 2000)
        }
    }

    // Alternative
    private settori = [{text: "Ortofrutta", value: ESettori.Ortofrutta},
        {text: "Florovivaismo", value: ESettori.Florovivaismo},
        {text: "Vite & Olivo", value: ESettori.ViteOlivo},
        {text: "Allevamento", value: ESettori.Allevamento}];


    get getAnnouncementUuid() {
        return this.announcementUuid || this._announcementUuid;
    }

    get announcement() {

        if (this.announcements) {
            return {
                ...this.defaultValues, ...this.announcements.find((item) => {
                    return item.id === this.getAnnouncementUuid
                })
            }
        } else {
            return {...this.defaultValues}
        }
    }

    private manageSave(invalid:boolean, errors:[]){
        if(invalid){
            //FIXME mi sembra strano che il pacchetto di validazione non permetta un metodo semplice per far riprendere il focus...
            (document.querySelector('input.is-invalid') as HTMLElement).focus()
        } else {
            this.saveAnnouncement();
        }
    }

    public saveAnnouncement() {
        this.saveState = 1;
        if (this.user) {
            if (this.getAnnouncementUuid && this.getAnnouncementUuid != 'new') {
                return firebase.firestore()
                    .collection('users')
                    .doc(this.user.id)
                    .collection('announcements')
                    .doc(this.getAnnouncementUuid)
                    .set(removeUndefined(this.announcement)).then(() => {
                        this.saveState = 2;
                        this.$emit('saved');
                    })
            } else {
                return firebase.firestore()
                    .collection('users')
                    .doc(this.user.id)
                    .collection('announcements')
                    .add(removeUndefined(this.announcement)).then((result) => {
                        this._announcementUuid = result.id
                        this.saveState = 2;
                        this.$emit('saved');
                    })
            }
        }
    }

    //@ts-ignore
    private getValidationState({dirty, validated, valid = null}) {
        return dirty || validated ? valid : null;
    }

}
